<template><span /></template>

<script>
import { baanRueJaiClient } from "@/dependencies";
import { Auth, setCookie } from "@/lib/cookie";
import Axios from "axios";

export default {
  name: 'AuthRedirect',
  data() {
    return {};
  },
  mounted() {
    const json = JSON.parse(window.name);

    setCookie(Auth.AccessToken, json.accessToken);
    setCookie(Auth.RefreshToken, json.refreshToken);
    localStorage.setItem("adminFirstName", json.adminFirstName);
    localStorage.setItem("adminLastName", json.adminLastName);
    localStorage.setItem("adminRole", json.adminRole);
    localStorage.setItem("adminRolePermission", json.adminRolePermission);
    localStorage.setItem("adminRoleId", json.adminRoleId);
    localStorage.setItem("adminId", json.adminId);
    localStorage.setItem("adminProjects", json.adminProjects);

    Axios.post(
      `${process.env.HOST}/api/admin/auth/retoken`,
      {},
      {
        headers: {
          Authorization: `Bearer ${json.refreshToken}`
        }
      }
    )
      .then(response => {
        if (response.status === 200) {
          const {accessToken} = response.data.accessToken;
          setCookie(Auth.AccessToken, accessToken);
          baanRueJaiClient.setAuthorizationToken(accessToken);

          this.$router.push({
            name: json.route,
            params: json.params
          });
        } else {
          this.$router.push({
            name: "Login"
          });
        }
      })
      .catch(e => {
        this.$router.push({
          name: "Login"
        });

        throw e;
      });
  }
};
</script>

<style scoped></style>
